import i18n from '@dms/i18n';

import {FluidReplacementServiceIntervals} from '../../core/types/RentalVehicle';
import {Field} from './primitives/Field';

interface NextFluidReplacementDatePickerProps {
  name: FluidReplacementServiceIntervals;
}

/**
 * Date picker component for displaying the calculated next fluid replacement date of a vehicle component.
 * This field is typically calculated automatically based on the last replacement date and replacement interval.
 * Used in service interval tracking to show when a fluid should be replaced next.
 *
 * @param props.name - The fluid name (e.g., 'brakeFluid', 'coolantFluid')
 */
export function NextFluidReplacementDatePicker(props: NextFluidReplacementDatePickerProps) {
  return (
    <Field
      type="apiDate"
      name={`serviceIntervals.${props.name}.nextReplacementDate`}
      label={i18n.t('entity.vehicle.labels.nextReplacementDate')}
    />
  );
}
